<app-lazy-loaded-component
  [definition]="
  {
    instance,
    module: definition.module,
    component: definition.component,
    inputs:
    {
      html
    },
    outputs:
    {
    }
  }"
></app-lazy-loaded-component>
